module.exports = __webpack_public_path__ + "static/img/0-5home.6c9b15df.jpg";